import api from "../services/api";
import _ from "lodash";
import odataMixin from '@/core/store/mixin/odata'
import crudMixin from '@/core/store/mixin/crud'

const appl =  {
  actions: {
    getItems({commit}, payload) {
      return api.getItems({ ...payload, expand: 'organization' })
        .then(response => ({
          items: response.data.items,
          totalCount: response.data.count
        }))
    }
  },
  namespaced: true,
}

const res = _.merge({},
  odataMixin(api),
  crudMixin(api),
  appl,
)

export default res
